import { render, staticRenderFns } from "./profileComplaint.vue?vue&type=template&id=a3d1cd04&"
import script from "./profileComplaint.vue?vue&type=script&lang=js&"
export * from "./profileComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports